import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleTemplate from '@/pages/article/components/ArticleTemplate';
import { securityArticle } from '@/mocks/articleData';

export default function SecurityArticle() {
  return (
    <>
      <Navbar />
      <ArticleTemplate article={securityArticle} />
      <Footer />
    </>
  );
}